<template>
  <div>
    <b-overlay
      :show="isLoading"
      spinner-variant="primary"
      color="#fff"
      rounded="lg"
    >
      <div class="w-100 pb-2 mb-3">
        <input
          type="text"
          v-model="query"
          placeholder="Пошук"
          class="w-100 filter"
        />
      </div>
      <div class="tags__list">
        <div
          class="item d-flex w-100 justify-content-between align-items-center"
          v-for="t in filteredTags"
          :key="t.name"
        >
          <a
            href="#"
            class="name"
            :style="{ background: getTagColor(t), color: invertHex(t) }"
            @click.prevent="startEditing(t)"
            >{{ t.name }}</a
          >
          <div class="d-flex justify-content-end">
            <b-button
              @click="startEditing(t)"
              variant="outline-primary"
              size="sm"
              class="edit d-flex align-items-center"
              ><b-icon-pencil />
            </b-button>
            <b-button
              @click="startRemoving(t)"
              style="margin-left: 10px"
              size="sm"
              variant="outline-danger"
              ><b-icon-trash />
            </b-button>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          @click="showAddModal = true"
          variant="primary"
          class="d-flex align-items-center"
          ><b-icon-plus /> &nbsp; Додати тег
        </b-button>
      </div>
    </b-overlay>
    <b-modal
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      v-model="showAddModal"
    >
      <b-overlay
        :show="modalLoading"
        spinner-variant="primary"
        color="#fff"
        rounded="lg"
      >
        <h2 class="mb-3"><b-icon-tag /> Додати новий тег</h2>
        <div class="py-2 my-2">
          <b-form-input
            v-model="new_tag.name"
            placeholder="Введіть назву тегу"
          ></b-form-input>
          <Twitter class="mt-3" v-model="new_tag.color" />
        </div>
        <div class="pt-2 mt-2">
          <b-button
            @click="saveTag"
            :disabled="disableButton"
            class="w-100"
            size="lg"
            variant="primary"
          >
            Зберегти
          </b-button>
          <b-button
            @click="showAddModal = false"
            class="w-100 mt-3"
            size="md"
            variant="outline-danger"
          >
            Скасувати
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      v-model="showEditModal"
    >
      <b-overlay
        :show="modalLoading"
        spinner-variant="primary"
        color="#fff"
        rounded="lg"
      >
        <h2 class="mb-3"><b-icon-tag /> Редагувати тег</h2>
        <div class="py-2 my-2">
          <b-form-input
            v-model="edit_tag.name"
            placeholder="Введіть назву тегу"
          ></b-form-input>
          <Twitter class="mt-3" v-model="edit_tag.color" />
        </div>
        <div class="pt-2 mt-2">
          <b-button
            @click="updateTag"
            :disabled="disableEditButton"
            class="w-100"
            size="lg"
            variant="primary"
          >
            Зберегти
          </b-button>
          <b-button
            @click="showEditModal = false"
            class="w-100 mt-3"
            size="md"
            variant="outline-danger"
          >
            Скасувати
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      v-model="showRemoveModal"
    >
      <h3 class="mb-3">Ви справді хочете видалити тег?</h3>
      <div class="my-4">
        <div class="tag">
          <strong
            v-if="edit_tag.color"
            :style="{ background: edit_tag.color.hex }"
            >{{ edit_tag.name }}</strong
          >
        </div>
      </div>
      <div class="pt-2 mt-2">
        <b-button @click="removeTag" class="w-100" size="lg" variant="danger">
          Видалити
        </b-button>
        <b-button
          @click="showRemoveModal = false"
          class="w-100 mt-3"
          size="md"
          variant="outline-primary"
        >
          Скасувати
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Twitter } from "vue-color";
export default {
  components: {
    Twitter,
  },
  data() {
    return {
      isLoading: false,
      modalLoading: false,
      showAddModal: false,
      showEditModal: false,
      showRemoveModal: false,
      query: "",
      new_tag: {
        name: "",
        color: "#ffffff",
      },
      edit_tag: {
        name: "",
        color: "#ffffff",
      },
      tags: [],
    };
  },
  computed: {
    disableButton() {
      let limit_min = 1;
      let limit_max = 18;
      let result = false;
      if (
        limit_min > this.new_tag.name.length ||
        this.new_tag.name.length > limit_max
      ) {
        result = true;
      }
      if (this.new_tag.name.indexOf(" ") >= 0) {
        result = true;
      }
      return result;
    },
    disableEditButton() {
      let limit_min = 1;
      let limit_max = 18;
      let result = false;
      if (
        limit_min > this.edit_tag.name.length ||
        this.edit_tag.name.length > limit_max
      ) {
        result = true;
      }
      console.log(result);
      if (this.edit_tag.name.indexOf(" ") >= 0) {
        result = true;
      }
      return result;
    },
    filteredTags() {
      let tags = this.tags;
      if (this.query.length) {
        let q = this.query.toLowerCase();
        tags = this.tags.filter((el) => {
          return el.name.toLowerCase().indexOf(q) > -1;
        });
      }

      return tags;
    },
  },
  methods: {
    invertHex(t) {
      let color = "#000";
      if (t.color && t.color.hex) {
        color = "#fff";
      }
      return color;
    },
    getTagColor(t) {
      let color = "#00000";
      if (t.color && t.color.hex) {
        color = t.color.hex;
      }

      return color;
    },
    startRemoving(tag) {
      this.edit_tag = Object.assign({}, tag);
      this.showRemoveModal = true;
    },
    startEditing(tag) {
      this.edit_tag = Object.assign({}, tag);

      this.showEditModal = true;
    },
    async checkIfTagExists() {
      this.isLoading = true;
      let found = false;
      let args = {
        collectionName: "tags",
        where: ["name", "==", this.new_tag],
        limit: 1,
      };
      let result = await this.$db.getCollection(args);
      if (result.docs.length > 0) {
        found = true;
      }

      this.isLoading = false;
      return found;
    },
    async fetchTags() {
      this.isLoading = true;
      let args = {
        collectionName: "tags",
      };
      let result = await this.$db.getCollection(args);
      this.tags = result.docs;
      this.isLoading = false;
    },
    async getNewId() {
      let result = await this.$api
        .get("/get/counter/?type=tags")
        .then((data) => {
          return data;
        })
        .catch((error) => {
          return error;
        });

      return result.data.count;
    },
    async saveTag() {
      this.modalLoading = true;
      let exists = await this.checkIfTagExists();
      if (!exists) {
        let id = await this.getNewId();
        let result = await this.$db.add("tags", {
          name: this.new_tag.name,
          id: id,
          color: this.new_tag.color,
        });
        if (result.success) {
          this.$toast.success("Тег збережено");
          this.showAddModal = false;
          this.new_tag = {
            name: "",
            color: "#ffffff",
          };
          this.fetchTags();
        }
      } else {
        this.$toast.error("Тег вже існує");
      }
      this.modalLoading = false;
    },
    async updateTag() {
      this.modalLoading = true;
      let exists = await this.checkIfTagExists();
      if (!exists) {
        let uid = this.edit_tag.uid;
        let result = await this.$db.update("tags", uid, {
          name: this.edit_tag.name,
          color: this.edit_tag.color,
        });
        console.log(result);
        if (result.success) {
          this.$toast.success("Тег збережено");
          this.showEditModal = false;
          this.fetchTags();
        }
      } else {
        this.$toast.error("Тег вже існує");
      }
      this.modalLoading = false;
    },
    async removeTag() {
      this.isLoading = true;

      let uid = this.edit_tag.uid;
      let result = await this.$db.delete("tags", uid);
      console.log(result);
      if (result.success) {
        this.$toast.success("Тег видалено");
        this.showRemoveModal = false;
        this.fetchTags();
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.fetchTags();
  },
};
</script>

<style lang="scss" scoped>
.name {
  padding: 0px 10px;
  text-decoration: none;
  border-radius: 6px;
}
.tag {
  strong {
    padding: 4px 6px;
    text-decoration: none;
    border-radius: 6px;
    color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(#000, 0.1);
    text-shadow: 0px 0px 5px rgba(#000, 0.2);
  }
}
.filter {
  border-radius: 4px;
  background: #e7e7e7;
  border: none;
  padding: 3px 12px;
  height: 32px;
  outline: none;
}
.item {
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: 1px solid #dee2e6;
}
.edit {
  color: rgb(12, 92, 109);
  border-color: rgb(12, 92, 109);
  &:hover {
    background: rgb(12, 92, 109);
    color: #ffff;
    border-color: rgb(12, 92, 109);
  }
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
}
</style>
